export const LOGIN = '/';
export const ALL_USERS = '/users';
export const ALL_REPORTED_USERS = '/reportedUsers';
export const CATEGORY = '/categories';
export const SKILLS = '/skills';
export const JOBS = '/jobs';
export const MATCHING_PERCENTAGE = '/matching-percentage';
